<template>
  <div class="container">
    <!-- <div class="top-title">
      <span class="text">缴费提醒</span>
    </div> -->
    <div class="top-btn">
      <el-button class="mwow-button-filled success" @click="openPushView"
        >批量推送</el-button
      >
      <el-button
        class="mwow-button-filled primary"
        @click="handleExport"
        v-debounce="1000"
        >导出</el-button
      >
      <el-button class="mwow-button-filled primary" @click="openRemindView"
        >提醒设置</el-button
      >
      <div class="early">
        预警值：剩余课时<span class="red"
          >≤{{ earlyData.renew_lesson_count }}课时</span
        ><span v-if="earlyData.renew_auto_switch == 1">，自动推送提醒</span>
      </div>
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleResetSearch">
      <el-form class="searchForm" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜素: " prop="student_id">
              <el-select
                v-model="searchInfo.student_id"
                placeholder="请选择"
                filterable
                clearable
                :filter-method="handleSearchStudentList"
                @focus="handleSearchStudentList('')"
                @change="handleSearchCourse"
              >
                <el-option
                  v-for="item in studentList"
                  :key="item.student_id"
                  :label="item.name"
                  :value="item.student_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="购买课程: " prop="course_id">
              <el-select
                v-model="searchInfo.course_id"
                placeholder="请选择"
                clearable
                filterable
                :filter-method="handleSearchCourseList"
                @focus="handleSearchCourseList('')"
                @change="handleSearchCourse"
              >
                <el-option
                  v-for="item in courseList"
                  :key="item.course_id"
                  :label="item.title"
                  :value="item.course_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程类型:">
              <el-radio-group
                v-model="searchInfo.course_type"
                @change="handleSearchCourse"
                size="mini"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">1vN</el-radio-button>
                <el-radio-button :label="2">1v1</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程顾问:" prop="follow_staff_ids">
              <common-staff-pull-down
                :originId.sync="searchInfo.follow_staff_ids"
                :defaultSelected.sync="staffList.followStaff"
                @change="handleSearchCourse"
                :multiple="true"
                :jobIds="[3]"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="教务老师:" prop="edu_teacher_ids">
              <common-staff-pull-down
                :originId.sync="searchInfo.edu_teacher_ids"
                :defaultSelected.sync="staffList.eduTeacher"
                @change="handleSearchCourse"
                :multiple="true"
                :jobIds="[2]"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程老师:" prop="relation_teacher_ids">
              <common-staff-pull-down
                :originId.sync="searchInfo.relation_teacher_ids"
                :defaultSelected.sync="staffList.relationTeacher"
                @change="handleSearchCourse"
                :multiple="true"
                :jobIds="[1]"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      class="table"
      size="mini"
      :data="tableData"
      v-horizontal-scroll
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      :row-key="(row) => `${row.index + 1}`"
      :tree-props="{ children: 'list' }"
      lazy
      default-expand-all
      @sort-change="handleSortChange"
      :default-sort="{
        order: 'descending',
        prop: 'create_time',
      }"
    >
      <el-table-column
        :selectable="handleSelect"
        type="selection"
        width="50"
        align="center"
      >
      </el-table-column>
      <el-table-column label="学员名称" prop="name" min-width="120">
        <template slot-scope="scope">
          <span
            v-if="scope.row"
            class="mwow-green small-hand"
            @click="goStudentDetail(scope.row.student_id)"
          >
            {{ scope.row.name || ""
            }}<span
              v-if="scope.row.is_del === 1"
              class="mwow-tag del-filled large"
              >已删除</span
            >
          </span>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="mobile" min-width="130">
        <template slot-scope="scope">
          {{
            scope.row.area_code
              ? "+" + scope.row.area_code + scope.row.mobile
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column label="购买课程" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.course ? scope.row.course.title : "-" }}
          <span class="red" v-if="scope.row.expire_status">（已到期）</span>
        </template>
      </el-table-column>
      <el-table-column label="课程类型" prop="course.course_type">
        <template slot-scope="scope">
          {{
            scope.row.course
              ? scope.row.course && scope.row.course.course_type == 1
                ? "1vN"
                : "1v1"
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
        prop="usable_number"
      >
        <template slot="header">
          <span>剩余课时</span>
          <el-popover
            placement="top"
            popper-class="followuppopover"
            trigger="hover"
            width="200"
          >
            <p>
              学员在剩余课时不足的情况下继续上课，多上的课时会标记为超上，请及时联系学员并续费补扣。
            </p>
            <i
              class="el-icon-question"
              slot="reference"
              style="
                margin: 0 0 0 8px;
                color: #bebfc0;
                font-size: 16px;
                vertical-align: text-bottom;
              "
            ></i>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <div class="yellow">
            {{
              scope.row.course ? Number(scope.row.usable_number) + "课时" : "-"
            }}
            <span
              class="red"
              v-if="scope.row.course && Number(scope.row.exceed_number) != 0"
              >(超上{{ Number(scope.row.exceed_number) }}课时)</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="课程顾问">
        <template slot-scope="scope">
          {{
            scope.row.staff
              ? scope.row.staff.name != ""
                ? scope.row.staff.name
                : "-"
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column label="教务老师">
        <template slot-scope="scope">
          {{
            scope.row.teacher
              ? scope.row.teacher.name != ""
                ? scope.row.teacher.name
                : "-"
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column label="课程老师">
        <template slot-scope="scope">
          <span
            v-if="
              scope.row.relation_teacher_list &&
              scope.row.relation_teacher_list.length > 0
            "
          >
            {{
              scope.row.relation_teacher_list
                .map((teacher) => {
                  return teacher.name;
                })
                .join("、")
            }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="上次提醒时间"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
        prop="last_remind_time"
        min-width="140"
      >
        <template slot-scope="scope">
          {{
            scope.row.last_remind_time
              ? scope.row.last_remind_time != 0
                ? getdate(
                    "YYYY-mm-dd HH:MM",
                    new Date(Number(scope.row.last_remind_time + "000"))
                  )
                : "-"
              : "-"
          }}
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="160" align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              class="mwow-button primary"
              @click="openRenew(scope.row)"
              v-if="orderCourseSwitch"
              >续费</el-button
            >
            <el-button
              class="mwow-button success"
              @click="renewremind(scope.row)"
              >续费提醒</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px', overflow: 'hidden' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <pushView
      v-if="pushViewbtn"
      :list="multipleSelection"
      @closeView="closePushView"
    />
    <remindeView
      v-if="remindViewbtn"
      :time="earlyData.renew_push_time"
      :switch="earlyData.renew_auto_switch"
      :lessonCount="earlyData.renew_lesson_count"
      @closeView="closeRemindView"
    />
  </div>
</template>
<script>
import { renewList, renewListExportApi } from "@/api/renewal";
import {
  searchStudent,
  getSelectCourseList,
  staffList,
} from "@/api/globalSearch";
import pushView from "../../renewalFrame/pushView.vue";
import remindeView from "../../renewalFrame/remindeView.vue";
import { dateFormat } from "@/utils/timeFormat";
import { exportLoop } from "@/utils/export";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import { mixin } from "@/mixin/tabPageInfoMixin";
import { UserModule } from "@/store/module/user";
export default {
  props: ["visible"],
  mixins: [mixin],
  components: {
    pushView,
    remindeView,
    commonStaffPullDown,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        course_id: "",
        student_id: "",
        course_type: -1,
        follow_staff_ids: [],
        edu_teacher_ids: [],
        relation_teacher_ids: [],
      },
      studentList: [], // 学员列表
      courseList: [], // 购买课程
      page: 1,
      pageSize: 10,
      tableData: [],
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      multipleSelection: [],
      chooseList: [],
      earlyData: {},
      pushViewbtn: false,
      remindViewbtn: false,
      staffList: {
        followStaff: [],
        eduTeacher: [],
        relationTeacher: [],
      },
    };
  },
  computed: {
    orderCourseSwitch() {
      return UserModule.userInfo.order_course_switch === 1;
    },
  },
  created() {
    let pageCache = sessionStorage.getItem(
      "teach-renew-manage-remind-page-cache"
    );
    if (pageCache) {
      let pageCacheJSON = JSON.parse(pageCache);
      if (pageCacheJSON.search_info) {
        this.searchInfo = pageCacheJSON.search_info;
        this.page = pageCacheJSON.page;
        this.pageSize = pageCacheJSON.page_size;
      }
    }
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleRefresh();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleRefresh();
    }
  },
  methods: {
    handleResetSearch() {
      this.searchInfo = {
        course_id: "",
        student_id: "",
        course_type: -1,
        follow_staff_ids: [],
        edu_teacher_ids: [],
        relation_teacher_ids: [],
      };
      this.handleSearchCourse();
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleSearchStaff(type, value) {
      if (type === "followStaff") {
        staffList({
          page: 1,
          page_size: 100,
          status: 1,
          key_word: value,
          job_ids: [3],
        }).then((res) => {
          if (res.error_code === 0) {
            this.staffList.followStaff = res.data.list;
          }
        });
      }
      if (type === "eduTeacher") {
        staffList({
          page: 1,
          page_size: 100,
          status: 1,
          key_word: value,
          job_ids: [2],
        }).then((res) => {
          if (res.error_code === 0) {
            this.staffList.eduTeacher = res.data.list;
          }
        });
      }
      if (type === "relationTeacher") {
        staffList({
          page: 1,
          page_size: 100,
          status: 1,
          key_word: value,
          job_ids: [1],
        }).then((res) => {
          if (res.error_code === 0) {
            this.staffList.relationTeacher = res.data.list;
          }
        });
      }
    },
    handleSearchStudentList(v) {
      searchStudent({
        page: 1,
        page_size: 1000,
        key_word: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentList = res.data.list;
        }
      });
    },
    // 过滤可选的项
    handleSelect(evt) {
      return evt.mobile;
    },
    handleSearchCourseList(v) {
      getSelectCourseList({
        page: 1,
        page_size: 1000,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseList = res.data.list;
        }
      });
    },
    goStudentDetail(sid) {
      this.mixinSavePageInfo("renewalList");
      this.$router.push({
        name: "studyDetails",
        query: {
          id: sid,
        },
      });
    },
    openPushView() {
      if (this.chooseList.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择学员",
        });
        return;
      }
      this.multipleSelection = this.chooseList;
      this.pushViewbtn = true;
    },
    openRemindView() {
      this.remindViewbtn = true;
    },
    getdate(a, b) {
      return dateFormat(a, b);
    },
    closePushView(e) {
      this.pushViewbtn = false;
      if (e == "push") {
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
      }
    },
    closeRemindView(e) {
      this.remindViewbtn = false;
      if (e == "keep") {
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
      }
    },
    handleSearchCourse() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleSelectionChange(arr) {
      this.chooseList = arr;
    },
    openRenew(e) {
      if (e.course.sales_status == 2) {
        this.$message({
          type: "error",
          message: "课程已关闭购买",
        });
        return;
      }
      this.mixinSavePageInfo("renewalList");
      this.$router.push({
        name: "buyCourseConfirm",
        query: { id: e.student_id, course_id: e.course_id },
      });
    },
    renewremind(e) {
      this.multipleSelection = [e];
      this.pushViewbtn = true;
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.course_type >= 0) {
        option.course_type = this.searchInfo.course_type;
      }
      if (this.searchInfo.course_id >= 0) {
        option.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.student_id >= 0) {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.sort_field) {
        option.sort_field = this.searchInfo.sort_field;
      }
      if (this.searchInfo.sort_type) {
        option.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.follow_staff_ids) {
        option.follow_staff_ids = this.searchInfo.follow_staff_ids;
      }
      if (this.searchInfo.edu_teacher_ids) {
        option.edu_teacher_ids = this.searchInfo.edu_teacher_ids;
      }
      if (this.searchInfo.relation_teacher_ids) {
        option.relation_teacher_ids = this.searchInfo.relation_teacher_ids;
      }
      sessionStorage.setItem(
        "teach-renew-manage-remind-page-cache",
        JSON.stringify({
          search_info: this.searchInfo,
          page: params.page,
          page_size: params.page_size,
        })
      );
      renewList(option).then((res) => {
        if (res.error_code === 0) {
          this.earlyData = res.data.config;
          // 为每颗树节点以及树的子节点做唯一标识 1-1,1-2,2-1 的形式
          res.data.renew.list.forEach((item, index) => {
            item.index = String(index + 1);
            if (item.list.length > 0) {
              // 兼容推送接口，做 student 的数据缓存
              item.student = {
                name: item.name,
              };
              // 兼容推送接口，做 student 的数据缓存
              item.list.forEach((it, ind) => {
                it.index = String(index + 1) + "-" + String(ind + 1);
                it.student = {
                  name: item.name,
                };
              });
              // 将子列表的第一项数据拿到外层展示，然后将子列表的第一项去除
              if (item.list && item.list.length > 0) {
                item.exceed_number = item.list[0].exceed_number;
                item.course_id = item.list[0].course_id;
                item.account_id = item.list[0].account_id;
                item.course = item.list[0].course;
                item.usable_number = item.list[0].usable_number;
                item.staff = item.list[0].staff;
                item.teacher = item.list[0].teacher;
                item.last_remind_time = item.list[0].last_remind_time;
                item.list.shift();
              }
            }
          });
          this.tableData = res.data.renew.list;
          this.page = params.page;
          this.total = res.data.renew.total;
        }
      });
    },
    handleSortChange(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleExport() {
      const option = {
        page: 1,
        page_size: 10,
      };
      if (this.searchInfo.course_type >= 0) {
        option.course_type = this.searchInfo.course_type;
      }
      if (this.searchInfo.course_id >= 0) {
        option.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.student_id >= 0) {
        option.student_id = this.searchInfo.student_id;
      }
      renewListExportApi(option).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
      this.mixinSavePageInfo("renewalList");
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
      this.mixinSavePageInfo("renewalList");
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  position: relative;
  height: calc(100% - 34px);
  min-height: calc(100vh - 220px);
  background: #fff;
  overflow: hidden;
  .top-btn {
    display: flex;
    margin-bottom: 12px;
  }
  .early {
    margin-left: 10px;
    padding: 0 10px;
    height: 28px;
    background: #fff7e9;
    color: #5c5d5e;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 29px;
  }
}
.top-title {
  border-bottom: 2px solid #e7e8ea;
  margin-bottom: 16px;
  .text {
    line-height: 43px;
    display: inline-block;
    font-size: 14px;
    color: #07d1aa;
    position: relative;
    padding: 0 12px;
    &:after {
      content: "";
      position: absolute;
      left: 22px;
      right: 22px;
      bottom: -1px;
      border-top: 2px solid #07d1aa;
    }
  }
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.yellow {
  color: #ffb940;
}
.red {
  color: #f56c6c;
}
.el-row {
  box-sizing: border-box;
  width: 100%;
}
.small-hand {
  cursor: pointer;
}
</style>
